import Marquee from "react-fast-marquee";
import shareAllotmentImg from "../../assets/images/share-allotment.png";
import { fpRealaatedArticales } from "../../data/relatedArticale";
import Faq from "../Faq";
import Meta from "../Meta";
;

export default function ShareAllotment() {
 const faqItems = [
    {
        title: 'What is share allotment in a company?',
        content: <strong>Share allotment is the process by which a company allocates new shares to shareholders or investors, either during company formation or in later funding rounds.</strong>
    },
    {
        title: 'Who can receive share allotment?',
        content: <strong>Shares can be allotted to existing shareholders, new investors, directors, or employees depending on the purpose and approval of the board and shareholders.</strong>
    },
    {
        title: 'Is approval required for allotting shares?',
        content: <strong>Yes, share allotment typically requires board resolution and filing with regulatory authorities such as the RJSC in Bangladesh.</strong>
    }
];

return (
    <>
        <Meta
            title="Share allotment procedure in Bangladesh | Allotment of Share"
            description="Share allotment procedure in Bangladesh. Step 1: Foreign citizens will remit money to the company's account from any of their foreign bank accounts."
            image={shareAllotmentImg}
            keywords="share allotment, allotment of share, company shares, issue of shares, share holding, RJSC compliance"
        />

        <div className="container-fluid hero-header bg-light py-5 mb-5">
            <div className="container py-5">
                <div className="row g-5 align-items-center">
                    <div className="col-lg-6">
                        <h1 className="display-4 mb-3 animated slideInDown">Share Allotment</h1>
                     <p>Share allotment is the process where a company issues and assigns new shares to either existing or new shareholders. This can be done to raise capital, bring in new business partners or existing directors</p>
                    </div>
                    <div className="col-lg-6 animated fadeIn">
                        <img className="img-fluid animated pulse infinite" style={{ animationDuration: '3s' }} src={shareAllotmentImg} alt='share-allotment-services' />
                    </div>
                </div>
            </div>
        </div>

        <div className="container-xxl py-5">
            <div className="container">
                <p className="color-text fs-5 mb-4"><b>What is Share Allotment?</b></p>
                <p>
                    Share allotment refers to the process by which a company issues new shares to shareholders or new investors. This usually occurs during company formation, capital expansion, or employee stock option plans. Allotting shares increases the company’s paid-up capital and changes the shareholding structure.
                    <br /><br />
                    Allotment of shares must follow the rules set out in the Companies Act of Bangladesh and the Articles of Association of the company. It requires formal approval, documentation, and regulatory filing to be legally valid.
                </p>

                <p className="color-text fs-5 mb-4"><b>Why is Share Allotment Important?</b></p>
                <p>
                    Share allotment is crucial for raising capital and expanding business operations. It allows companies to onboard new investors, reward employees, and adjust ownership for strategic reasons. When done properly, it ensures transparency, legal protection, and compliance with the Registrar of Joint Stock Companies (RJSC).
                </p>
            </div>
        </div>

        <div className="container-xxl py-5">
            <div className="container">
                <div className="row g-5 align-items-center">
                    <div className="col-lg-6">
                        <img className="img-fluid" src={shareAllotmentImg} alt='share-allotment-process' />
                    </div>
                    <div className="col-lg-6">
                        <div className="h-100">
                            <p className="color-text fs-5 mb-4">
                                What services does ‘JK Associates’ provide regarding Share Allotment?
                            </p>
                            <p>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                    <span><b>Preparation of Share Allotment Documentation: </b>We draft allotment letters, shareholder resolutions, and necessary forms.</span>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                    <span><b>Board Meeting Support: </b>We assist in conducting board meetings for approval of share allotment.</span>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                    <span><b>RJSC Filing: </b>We submit necessary filings to RJSC to record the share allotment in official records.</span>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                    <span><b>Capital Structure Update: </b>We help update the shareholding structure and issue updated share certificates.</span>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                    <span><b>Legal Compliance: </b>Ensure compliance with the Companies Act and company charter.</span>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                    <span><b>Consultation: </b>We advise on appropriate share allotment ratios, valuations, and documentation procedures.</span>
                                </div>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="container-xxl py-0">
            <div className="container">
                <p className="color-text fs-5 mb-4"><b>The Process of Share Allotment</b></p>
                <p>
                    The typical process involves:
                    <br /><br />
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span><b>Board Approval: </b>Hold a board meeting to approve the share allotment.</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span><b>Prepare Allotment Letters: </b>Send formal notices to shareholders or investors.</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span><b>Update Share Register: </b>Record the allotment in the company’s share register.</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span><b>Issue Share Certificates: </b>Provide updated certificates to new shareholders.</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span><b>File with RJSC: </b>Submit the allotment form and supporting documents to RJSC.</span>
                    </div>
                </p>

                <p className="color-text fs-5 mb-4"><b>Documents Required for Share Allotment</b></p>
                <p>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Board Resolution approving share allotment</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Share allotment return (RJSC form)</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Updated Share Register</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Allotment letters and identity proof of allottees</span>
                    </div>
                </p>

                <p className="color-text fs-5 mb-4"><b>Things to Consider During Share Allotment</b></p>
                <p>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Ensure availability of authorized capital to issue new shares</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Valuation of shares and investment terms</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Transparency and consent from existing shareholders</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                        <span>Complying with RJSC and tax regulations</span>
                    </div>
                </p>
                  <p>
                    Share allotment is the process where a company issues and assigns new shares to either existing or new shareholders. This can be done to raise capital, bring in new business partners, or fulfill contractual obligations. Essentially, it's the mechanism by which a company increases its share capital and distributes ownership.
                    <br /><br />
                    Share allotment can be part of a contractual agreement, like employee stock options or dividend payments. It can also be used to change the proportion of shares held by existing shareholders.
                </p>
            </div>
        </div>

        <div className='container-xxl center-background1'>
            <h2> Related Articles</h2>
        </div>

        <div className='container-xxl center-background1'>
            <Marquee className="marquee-container">
                {fpRealaatedArticales}
            </Marquee>
        </div>

        <div className="container py-5 my-0">
            <h2 className="color-text text-center mb-4">Share Allotment FAQ</h2>
            <Faq items={faqItems} />
        </div>
    </>
)

}
